'use client';

import { type CSSProperties } from 'react';
import { cn } from '../../lib/cn';
import { SRadio, type SRadioValue } from './SRadio';

export interface SRadioOption {
  /** 옵션 값 (sd-radio-group SRadioOption.value) */
  value: SRadioValue;
  label: string;
  disabled?: boolean;
}

export interface SRadioGroupProps {
  /** 옵션 목록 */
  options?: SRadioOption[];
  /** 현재 선택 값 */
  value?: SRadioValue | null;
  /** 배치 방향 */
  direction?: 'vertical' | 'horizontal';
  /** 전체 비활성 */
  disabled?: boolean;
  /** 라디오 name 속성 (form-agnostic 그룹핑) */
  groupName?: string;
  /** 선택 변경 (sdUpdate) */
  onValueChange?: (val: SRadioValue) => void;
  className?: string;
  style?: CSSProperties;
}

/** SRadioGroup — sd-radio-group 포팅. options를 SRadio로 렌더. */
export function SRadioGroup({
  options = [],
  value,
  direction = 'vertical',
  disabled = false,
  groupName,
  onValueChange,
  className,
  style,
}: SRadioGroupProps) {
  return (
    <div
      role="radiogroup"
      className={cn(
        'inline-flex',
        direction === 'vertical'
          ? 'flex-col gap-[var(--cmp-radio-group-gap-vertical)]'
          : 'flex-row gap-[var(--cmp-radio-group-gap-horizontal)]',
        className,
      )}
      style={style}
    >
      {options.map(o => (
        <SRadio
          key={String(o.value)}
          val={o.value}
          value={value}
          label={o.label}
          name={groupName}
          disabled={disabled || o.disabled}
          onValueChange={onValueChange}
        />
      ))}
    </div>
  );
}
